"use client";

import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "@/lib/utils";

function Slider({
  className,
  value,
  onValueChange,
  min = 0,
  max = 100,
  step = 1,
  minStepsBetweenThumbs = 0,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
  const values = value ?? props.defaultValue ?? [min, max];
  const arr = Array.isArray(values) ? values : [values];

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      value={value}
      onValueChange={onValueChange}
      min={min}
      max={max}
      step={step}
      minStepsBetweenThumbs={minStepsBetweenThumbs}
      className={cn(
        "relative flex w-full touch-none select-none items-center py-2",
        "min-h-10 overflow-hidden",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot="slider-track"
        className="relative h-2 w-full grow overflow-hidden rounded-full bg-input"
      >
        <SliderPrimitive.Range
          data-slot="slider-range"
          className="absolute h-full bg-primary"
        />
      </SliderPrimitive.Track>
      {arr.map((_, i) => (
        <SliderPrimitive.Thumb
          key={i}
          data-slot="slider-thumb"
            className={cn(
              "block size-5 rounded-full border-2 border-primary bg-background shadow-xs transition-colors",
              "focus-visible:outline-hidden focus-visible:ring-3 focus-visible:ring-ring focus-visible:ring-inset",
              "disabled:pointer-events-none disabled:opacity-50"
            )}
        />
      ))}
    </SliderPrimitive.Root>
  );
}

export { Slider };
